import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, MapPin, Database, Mail } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="mt-12 border-t border-slate-200 bg-gradient-to-b from-slate-100 to-slate-50">
        <div className="container mx-auto px-4 py-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="flex gap-3">
              <div className="shrink-0 w-10 h-10 rounded-xl bg-gradient-to-br from-nordicBlue/15 to-nordicBlue/5 flex items-center justify-center">
                <Building2 className="h-5 w-5 text-nordicBlue" strokeWidth={2} />
              </div>
              <div>
                <h3 className="text-sm font-semibold text-deepCharcoal uppercase tracking-wide mb-2">Kommunale avgifter</h3>
                <p className="text-deepCharcoal/80 text-sm leading-relaxed">
                  Interaktiv visualisering for norske boliger på 120 m².
                  Data fra SSB.
                </p>
              </div>
            </div>
            
            <div>
              <h3 className="text-sm font-semibold text-deepCharcoal uppercase tracking-wide mb-3 flex items-center gap-2">
                <MapPin className="h-4 w-4 text-nordicBlue" />
                Sider
              </h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-deepCharcoal/90 hover:text-nordicBlue transition-colors">Hjem</Link></li>
              <li><Link to="/sammenlign" className="text-deepCharcoal/90 hover:text-nordicBlue transition-colors">Sammenlign</Link></li>
              <li><Link to="/kart" className="text-deepCharcoal/90 hover:text-nordicBlue transition-colors">Kart</Link></li>
              <li><Link to="/del" className="text-deepCharcoal/90 hover:text-nordicBlue transition-colors">Lag widget</Link></li>
              <li><Link to="/om" className="text-deepCharcoal/90 hover:text-nordicBlue transition-colors">Om prosjektet</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-deepCharcoal uppercase tracking-wide mb-3 flex items-center gap-2">
              <Database className="h-4 w-4 text-nordicBlue" />
              Datakilder
            </h3>
            <ul className="space-y-2 text-sm">
              <li><a href="https://www.ssb.no" target="_blank" rel="noopener noreferrer" className="text-deepCharcoal/90 hover:text-nordicBlue transition-colors">Statistisk sentralbyrå (SSB)</a></li>
              <li><a href="https://www.ssb.no/statbank/table/12842/" target="_blank" rel="noopener noreferrer" className="text-deepCharcoal/90 hover:text-nordicBlue transition-colors">Tabell 12842</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-deepCharcoal uppercase tracking-wide mb-3 flex items-center gap-2">
              <Mail className="h-4 w-4 text-nordicBlue" />
              Kontakt
            </h3>
            <p className="text-deepCharcoal/80 text-sm">
              <a href="mailto:kontakt@kommunaleavgifter.no" className="hover:text-nordicBlue transition-colors">kontakt@kommunaleavgifter.no</a>
            </p>
            <p className="text-deepCharcoal/80 text-sm mt-2">
              Utviklet av{' '}
              <a href="https://roste-consulting.no" target="_blank" rel="noopener noreferrer" className="hover:text-nordicBlue transition-colors">
                Roste Consulting
              </a>
            </p>
          </div>
        </div>
        
        <div className="mt-10 pt-6 border-t border-slate-200 flex flex-col sm:flex-row justify-between items-center gap-3 text-sm text-deepCharcoal/70">
          <p className="font-medium">© {currentYear} Kommunale avgifter</p>
          <p className="text-xs flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-nordicBlue/60" />
            Data fra SSB · standardbolig 120 m²
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
